import { render, staticRenderFns } from "./QuestionBank.vue?vue&type=template&id=72859ebc&scoped=true"
import script from "./QuestionBank.vue?vue&type=script&lang=js"
export * from "./QuestionBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72859ebc",
  null
  
)

export default component.exports